import * as React from 'react';
import S from './TitleAndIntroduction.styles';
const TitleAndIntroduction = (props) => {
    if (!props.title && !props.introduction) {
        return null;
    }
    return React.createElement(S.Container, { "data-alignment": props.alignment ?? 'left' },
        props.title && React.createElement(S.Title, null, props.title),
        props.introduction && React.createElement(S.Introduction, null, props.introduction));
};
export default TitleAndIntroduction;
